import createLucideIcon from '../createLucideIcon';

const ArrowUpCircle = createLucideIcon('ArrowUpCircle', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '16 12 12 8 8 12', key: '1gpmhk' }],
  ['line', { x1: '12', x2: '12', y1: '16', y2: '8', key: '1n8uid' }],
]);

export default ArrowUpCircle;
